module.exports = __webpack_public_path__ + "h5/img/register-text.68b347dc.png";